import { useMemo } from 'react';

import { useSearchParams } from 'next/navigation';

export const useUrlParams = () => {
  const searchParams = useSearchParams();

  const urlParams = useMemo(() => {
    return {
      id: searchParams.get('id'),
      TxnId: searchParams.get('clientTransactionId'),
      cont: searchParams.get('cont'),
      emailVerification: searchParams.get('emailVerified'),
      unlimit: searchParams.get('deposit'),
      unlimitGateway: searchParams.get('gateway'),
      unlimitTxn: searchParams.get('txn'),
      isIntercom: searchParams.get('chat'),
      urlBonusParam: searchParams.get(process.env.NEXT_PUBLIC_URL_VAR_BONUS_PARAM!),
      payphone: searchParams.get('payphone'),
    };
  }, [searchParams]);

  return urlParams;
};
